import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import colorsJsonGreen from '../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from '../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from '../../../../assets/teiasoft-themes/silver.json';

export class TTButton{
  id?: number;
  icon?: string;
  secondaryIcon?: string;
  disabled?: boolean;
  tooltip?:string;
  rawTooltip?: string;
  secondaryTooltip?: string;
  secondaryRawTooltip?: string;
  size?: string;
  text?: string;
  rawText?: string;
  action?: string;
  secondaryAction?: string;
  type?:string;
  state?: string;
  toggleText?:string;
  active?: boolean | null;
}

@Component({
  selector: 'teiasoft-toolbar',
  templateUrl: './teiasoft-toolbar.component.html',
  styleUrls: ['./teiasoft-toolbar.component.scss']
})
export class TeiasoftToolbarComponent implements OnInit, OnChanges{
  @Input() buttonsList: TTButton[] = new Array();
  @Input() theme: string = 'silver';
  @Input() noMargin: boolean = false;

  @Output() onBtnClick: EventEmitter<TTButton> = new EventEmitter();

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["buttonsList"]){
      this.buttonsList = new Array();
      this.buttonsList = changes["buttonsList"].currentValue;
    }

    if (changes && changes["noMargin"]){
      this.noMargin = changes["noMargin"].currentValue;
    }
  }


  /* EVENTS */
  onTTClick(btn: TTButton){
    if (btn.type == 'toggle'){
      let _i: number = this.buttonsList.findIndex(x => x.id == btn.id);
      this.buttonsList[_i].state = 'pressed';
      for (var x = 0; x < this.buttonsList.length; x++) {
        if (_i != x) this.buttonsList[x].state = '';
      }
    }

    this.onBtnClick.emit(btn);
  }

  onTTSecondaryClick(btn: TTButton, event: MouseEvent){
    event.preventDefault();
    event.stopPropagation();
    if (!btn.secondaryAction || btn.secondaryAction == '') return;

    let _btn: TTButton = new TTButton();
    _btn = { ...btn, action: btn.secondaryAction };
    this.onBtnClick.emit(_btn);
  }
}
